import type { ISerialize } from '@/objects/ISerialize';

export class IBUSportRace implements ISerialize {
    public readonly Description: string | null;

    public readonly RaceId: string | null;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Description?: string | null; RaceId?: string | null }) {
        this.Description = values.Description ?? null;

        this.RaceId = values.RaceId ?? null;
    }

    public serialize(): string {
        return '{' + `"Description": ${JSON.stringify(this.Description)}` + ',' + `"RaceId": ${JSON.stringify(this.RaceId)}` + '}';
    }

    /**
     * Creates an instance of IBUSportRace from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {}): IBUSportRace {
        return new IBUSportRace(values);
    }

    public static _FromServerJson(json: any): IBUSportRace {
        return new IBUSportRace({ Description: json.Description ?? '', RaceId: json.RaceId ?? '' });
    }

    /**
     * Creates an instance of IBUSportRace from another instance of IBUSportRace.
     * @param other The IBUSportRace you want to clone
     * @returns A cloned IBUSportRace
     */
    public static FromOther(other: IBUSportRace): IBUSportRace {
        return IBUSportRace._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return IBUSportRace.FromOther(this);
    }

    static NAME_OF_CLASS = 'IBUSportRace';
}
